/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { some } from 'lodash';
import { MatOption } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { DropDownData, DropDownConfiguration, ISubDetails } from './models/dropdown';
@Component({
  selector: 'viavi-common-dropdown',
  templateUrl: './common-dropdown.component.html',
  styleUrls: ['./common-dropdown.component.scss']
})
export class CommonDropdownComponent implements OnInit, OnChanges {
  @ViewChild('mySelect') mySelect;
  /* To pass the data into dropdown */
  @Input()
  dropDownData: DropDownData[];
  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultSelection: any;
  /* To enable multiselct */
  @Input()
  configuration: DropDownConfiguration;
  /** To decide whether it is custome dropdown or not */
  @Input()
  isCustomDropdown: boolean;
  @Output() valueChange: EventEmitter<MatSelectChange | DropDownData[]> = new EventEmitter<
    MatSelectChange | DropDownData[]
  >();
  @Output() doneSelected: EventEmitter<MatSelectChange | DropDownData[]> = new EventEmitter<
    MatSelectChange | DropDownData[]
  >();
  @Output() editAction: EventEmitter<boolean> = new EventEmitter<boolean>();

  selected: DropDownData[];
  subDetailsClicked: boolean;
  selectedsubDetails: string;
  filteredDropDownData: DropDownData[];

  isDone: boolean;
  selectedIndex: number;
  selectedOptions = [];
  searchField: string;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dropDownData) {
      this.filteredDropDownData = Object.assign([], this.dropDownData);
      this.setDefaultSelection();
    }
    if (changes.defaultSelection) {
      this.setDefaultSelection();
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
    this.filteredDropDownData = Object.assign([], this.dropDownData);
    if (this.defaultSelection) {
      this.selected = this.defaultSelection;
      this.selectedIndex = this.filteredDropDownData.findIndex(
        defaultValue => defaultValue.key === this.defaultSelection.key
      );
      if (Array.isArray(this.selected) && this.selected.length > 0) {
        this.isDone = this.configuration.isButtonEnabled;
      }
    }
  }

  setDefaultSelection() {
    this.selected = this.defaultSelection;
    this.selectedOptions = this.defaultSelection;
    this.selectedIndex = this.filteredDropDownData.findIndex(
      defaultValue => defaultValue.key === this.defaultSelection?.key
    );
  }
  valueChanged(event: MatSelectChange) {
    this.selected = event.value;
    if (!(typeof event.value === 'string')) {
      event.value.selectedSubDetails = this.subDetailsClicked ? this.selectedsubDetails : undefined;
      this.selected = event.value;
    }
    this.subDetailsClicked = false;
    if (!this.configuration.isMultiselect) {
      this.valueChange.emit(this.selected);
    }
  }
  openSubDetails(data: DropDownData): void {
    const entry = data.subDetails.some(item => item.isOpen);
    data.subDetails.map(item => {
      item.isOpen = !entry;
      data.subDetailsVisibility = !entry;
    });
  }

  onKey(value) {
    if (!value) {
      this.filteredDropDownData = Object.assign([], this.dropDownData);
      this.maintainSubDetail();
      let hideDropdownOptions = [];
      if (this.selectedOptions && this.selectedOptions.length > 0) {
        hideDropdownOptions = this.selectedOptions.filter(item => item.hideDropdown);
      }
      const checkedOptions = this.dropDownData.filter(item => item.checked);
      hideDropdownOptions = this.formatData(hideDropdownOptions, checkedOptions);
      this.selectedOptions = checkedOptions.concat(hideDropdownOptions);
      return;
    }
    this.search(value);
  }

  doneClick() {
    this.doneSelected.emit(this.selectedOptions);
    this.isDone = true;
    this.mySelect.close();
  }

  openChange(event) {
    this.isDone = !event;
    this.searchField = '';
    this.search(this.searchField);
    this.mySelect.options.forEach(matOption => {
      if (matOption.value?.subContent2?.length) {
        const option = this.selectedOptions.find(item => item.key === matOption.value.key);
        if (option) {
          matOption.value.subContent2 = option.subContent2;
          matOption.value.subContent = option.subContent;
        }
      }
    });
    if (this.selectedOptions) {
      const selectedOption = this.configuration.isMultiselect
        ? this.selectedOptions
        : [this.selectedOptions];
      const result = this.mySelect.options.filter(matOption =>
        selectedOption.some(
          defaultValue => matOption.value?.key === defaultValue.key && !defaultValue.hideDropdown
        )
      );
      result.forEach(element => {
        element.select();
      });
      this.dropDownData.filter(item => {
        const filterData = selectedOption.find(
          selectedValue => item.key === selectedValue.key && !selectedValue.hideDropdown
        );
        if (filterData) {
          item.checked = true;
        }
      });
    }
    if (!this.selected || this.selected?.length == 0) {
      this.isDone = false;
    }
    if (!event) {
      this.doneClick();
    }
  }

  handleSubDetailsClick(subDetails: ISubDetails) {
    this.selectedOptions = this.dropDownData.filter(item => item.key === subDetails.key);
    this.selectedsubDetails = subDetails.value;
    this.subDetailsClicked = true;
    this.valueChange.emit(this.selectedOptions);
  }

  search(value: string) {
    this.filteredDropDownData = Object.assign([], this.dropDownData);
    if (
      this.configuration.searchConfiguration &&
      (this.configuration.searchConfiguration.isNameAllowed ||
        this.configuration.searchConfiguration.isAliasAllowed ||
        this.configuration.searchConfiguration.isSubContentAllowed ||
        this.configuration.searchConfiguration.isSubContent1Allowed ||
        this.configuration.searchConfiguration.isSubDetailsAllowed)
    ) {
      this.filteredDropDownData = this.getFilterData(value);
      this.maintainSubDetail();
    } else {
      this.filteredDropDownData = this.filteredDropDownData.filter(searchDropdown =>
        searchDropdown.value.toLowerCase().includes(value.toLowerCase())
      );
    }
  }

  maintainSubDetail() {
    this.filteredDropDownData.filter(item => {
      if (item.subDetails) {
        item.subDetails.filter(data => {
          if (this.searchField) {
            if (data.value.toLowerCase().indexOf(this.searchField) > -1) {
              data.isOpen = true;
            } else {
              data.isOpen = false;
            }
          } else {
            data.isOpen = false;
          }
        });
        if (item.subDetails.some(detail => detail.isOpen)) {
          item.subDetailsVisibility = true;
        } else {
          item.subDetailsVisibility = false;
        }
      }
    });
  }

  getFilterData(filterText) {
    const filteredText = filterText.toLowerCase();
    this.filteredDropDownData = Object.assign([], this.dropDownData);
    return this.filteredDropDownData.filter(data => {
      return some(data, (value, key) => {
        switch (key) {
          case 'value':
          case 'subContent':
          case 'alias':
          case 'subContent1':
          case 'location':
            return value.toLowerCase().indexOf(filteredText) > -1;
          case 'subContent2':
            return value.some(item => item.reflectorIp.toLowerCase().indexOf(filteredText) > -1);
          case 'subDetails':
            return value.some(item => item.value.toLowerCase().indexOf(filteredText) > -1);
            break;
          default:
            return false;
        }
      });
    });
  }

  editHub(selectedOption) {
    this.mySelect.close();
    this.editAction.emit(selectedOption);
  }

  editEndpoint(selectedOption) {
    this.mySelect.close();
    this.editAction.emit(selectedOption);
  }

  removeEndpoint(selectedOption) {
    let removedData;
    if (selectedOption.hideDropdown) {
      removedData = selectedOption;
    } else {
      removedData = this.dropDownData.find(item => item.key === selectedOption.key);
    }

    removedData.checked = false;
    if (removedData.subContent2?.length) {
      removedData.subContent2.forEach(item => (item.value = false));
    }
    this.selectedOptions = this.selectedOptions.filter(item => item.key !== selectedOption.key);
    if (!this.selectedOptions.length) {
      this.isDone = false;
      this.dropDownData.forEach(item => (item.checked = false));
    }
    this.valueChange.emit(this.selectedOptions);
  }

  selectAllToggle(event) {
    if (event.checked) {
      this.mySelect.options.forEach((item: MatOption) => {
        if (!item.disabled) {
          item.select();
        }
      });
    } else {
      this.mySelect.options.forEach((item: MatOption) => item.deselect());
      this.isDone = false;
    }

    this.filteredDropDownData.filter(item => {
      if (item.subContent2.length) {
        item.subContent2.forEach(list => {
          list.value = false;
        });
        item.subContent2[0].value = event.checked;
      }
      item.checked = !item.disabled ? event.checked : false;
    });
    this.dropDownData.filter(filter => {
      const filterData = this.filteredDropDownData.find(
        item => item.key === filter.key && item.checked && !item.disabled
      );
      if (filterData) {
        filter.checked = true;
      }
    });
    this.selectedOptions = this.dropDownData.filter(item => item.checked && !item.disabled);
  }
  isCheckedAll() {
    if (this.selected?.length) {
      const checkedData = this.filteredDropDownData.filter(item => item.checked);
      const enabledFilteredData = this.filteredDropDownData.filter(item => !item.disabled);
      return checkedData?.length == enabledFilteredData.length;
    }
  }
  handleAgentAndSiteClick() {
    if (this.selected && this.selected['selectedSubDetails']) {
      this.selected['selectedSubDetails'] = undefined;
      this.valueChange.emit(this.selected);
    }
  }
  optionClicked(data) {
    if (data.disabled && data.checked) {
      data.checked = false;
    }
    if (!data.disabled) {
      this.selectedIndex = this.filteredDropDownData.findIndex(
        defaultValue => defaultValue.key === data.key
      );
      data.checked = !data.checked;

      if (data.subContent2 && data.subContent2.length) {
        if (!data.checked) {
          data.subContent = data.model;
          data.subContent1 = '';
          data.subContent2.forEach(item => (item.value = false));
        } else {
          data.subContent2[0].value = true;
          const filterData = data.subContent2.find(item => item.value);
          data.subContent1 = filterData.testName;
          data.subContent =
            data.model + ' ' + data.subContent2[0].reflectorIp + ' ' + filterData?.phyId ?? '';
        }
      }
    }
    let hideDropdownOptions = [];
    if (this.selectedOptions && this.selectedOptions.length > 0) {
      hideDropdownOptions = this.selectedOptions.filter(item => item.hideDropdown);
    }

    const checkedOptions = this.dropDownData.filter(item => item.checked);
    hideDropdownOptions = this.formatData(hideDropdownOptions, checkedOptions);
    this.selectedOptions = checkedOptions.concat(hideDropdownOptions);
    if (!this.configuration.isMultiselect) {
      this.selected = data;
      this.valueChange.emit(this.selected);
    }
  }

  changeReflector(event, data, data1) {
    data1.subContent2.forEach(item => {
      if (item.id === data.id && event.checked) {
        item.value = true;
      } else {
        item.value = false;
      }
    });
    const result = this.mySelect.options.filter(matOption => {
      return matOption.value?.key === data1.key;
    });
    const checkedCheckbox = data1.subContent2.find(item => item.value);

    if (!checkedCheckbox) {
      result[0].deselect();
      data1.checked = false;
      data1.subContent = data1.model;
      data1.subContent1 = '';
    } else {
      result[0].select();
      data1.checked = true;
      data1.subContent1 = data.testName;
      data1.subContent =
        data1.model + ' ' + checkedCheckbox.reflectorIp + ' ' + checkedCheckbox.phyId ?? '';
    }
    this.selectedOptions = this.dropDownData.filter(item => item.checked);
  }
  formatData(hideDropdownData: any, selectedData): any {
    hideDropdownData.forEach((item, index) => {
      if (selectedData.find(e => e.key === item.key)) {
        hideDropdownData.splice(index, 1);
      }
    });
    return hideDropdownData;
  }
}
